export default __webpack_public_path__ + "static/media/onboardingLogo.c8520ee8.png";